import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../ui/atoms';

const INPUT_CLASSES = "form-input-inset";

const QuestionDrawer = ({ 
  isOpen, 
  mode, 
  currentQuestion, 
  onQuestionChange, 
  onSave, 
  onCancel 
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 overflow-hidden z-50">
      {/* Overlay */}
      <div className="absolute inset-0 overflow-hidden">
        <div 
          className="absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity" 
          onClick={onCancel}
        />
        
        <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
          <div className="pointer-events-auto w-screen max-w-md">
            <div className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl">
              <div className="flex-1 overflow-y-auto py-6 px-6">
                <div className="flex items-start justify-between">
                  <h2 className="text-lg font-medium text-gray-900">
                    {mode === 'add' ? 'Add New Question' : 'Edit Question'}
                  </h2>
                  <div className="ml-3 flex h-7 items-center">
                    <button
                      type="button"
                      className="relative -m-2 p-2 text-gray-400 hover:text-gray-500"
                      onClick={onCancel}
                    >
                      <span className="absolute -inset-0.5"></span>
                      <span className="sr-only">Close panel</span>
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="h-6 w-6">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>
                </div>
                
                <div className="mt-8">
                  <div className="space-y-6">
                    <div>
                      <label htmlFor="question" className="block text-sm font-medium text-gray-700">
                        Question Text (shown to user)
                      </label>
                      <div className="mt-1">
                        <input
                          id="question"
                          name="question"
                          type="text"
                          className={INPUT_CLASSES}
                          value={currentQuestion.question}
                          onChange={onQuestionChange}
                          placeholder={t('widgets.config.questionText')}
                        />
                      </div>
                    </div>
                    
                    <div>
                      <label htmlFor="prompt" className="block text-sm font-medium text-gray-700">
                        Prompt (optional, defaults to question)
                      </label>
                      <div className="mt-1">
                        <input
                          id="prompt"
                          name="prompt"
                          type="text"
                          className={INPUT_CLASSES}
                          value={currentQuestion.prompt}
                          onChange={onQuestionChange}
                          placeholder={t('widgets.config.promptDesc')}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="border-t border-gray-200 p-4 sm:px-6">
                <div className="flex justify-end space-x-3">
                  <Button type="button" variant="secondary" size="md" onClick={onCancel}>
                    {t('widgets.config.actions.cancel')}
                  </Button>
                  <Button type="button" onClick={onSave} variant="primary" size="md">
                    {mode === 'add' ? 'Add Question' : 'Save Changes'}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuestionDrawer;

